import { cn } from '@/lib/utils';

interface EyebrowProps {
  children: React.ReactNode;
  variant?: 'mono' | 'serif' | 'rules';
  className?: string;
  as?: 'p' | 'span' | 'div';
  align?: 'left' | 'center';
}

/**
 * Editorial eyebrow label. Used above titles, in card headers, and in section
 * intros. Three variants: plain monospace, serif italic, or monospace flanked
 * by hairline rules ("rules").
 */
export const Eyebrow = ({
  children,
  variant = 'mono',
  className,
  as: Tag = 'p',
  align = 'left',
}: EyebrowProps) => {
  if (variant === 'rules') {
    return (
      <Tag className={cn('editorial-rule', align === 'center' && 'mx-auto', className)}>
        {children}
      </Tag>
    );
  }
  if (variant === 'serif') {
    return (
      <Tag
        className={cn(
          'font-display italic text-sm tracking-wide text-brass',
          align === 'center' && 'text-center',
          className,
        )}
      >
        {children}
      </Tag>
    );
  }
  return (
    <Tag
      className={cn(
        'font-mono text-[10px] tracking-editorial uppercase text-brass/90',
        align === 'center' && 'text-center',
        className,
      )}
    >
      {children}
    </Tag>
  );
};